module.exports = __webpack_public_path__ + "static/media/plano_san_antonio.98078a98.png";